import { fetchApi } from '../utils/fetchApi'

export const unitList = () => fetchApi({
  path: '/unit/list',
})
